// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"Q1-z"};